import React from "react";
import ProfileContainer from "containers/Profile";
import { tracker } from "library/tracker";

/** Content only — chrome comes from shared AllInOneLayout in AllInOneRoutes. */
const Profile = () => {
  React.useEffect(() => {
    tracker.pageView();
  }, []);
  return <ProfileContainer />;
};

export default Profile;
